<template>
  <div class="pano-video-box">
    <a-form-model :rules="panoramicRules" ref="panoramicform" :model="panoramicform">
      <a-form-model-item ref="cover" :label="$t('form.common.field.cover.label')" prop="cover">
        <div class="pano-video-cover">
          <span class="tips">{{ $t("form.common.field.cover.tip") }}</span>
          <div class="pano-cover" :style="{ backgroundImage: 'url(' + panoramicform.cover + ')' }">
            <div class="close-cover" v-if="panoramicform.cover" @click.stop="panoramicform.cover = ''">
              <a-icon type="delete" />
            </div>
            <DragUploader ref="uploaderCover" uptype="cover" :callback="getUploaderCover">
              <a-spin :spinning="uploadingCover" :tip="$t('message.uploading')" slot="body">
                <div class="cover-data" v-show="!panoramicform.cover">
                  <span><a-icon type="plus" /></span>
                  <h4>{{ $t("form.common.field.cover.label") }}</h4>
                </div>
              </a-spin>
            </DragUploader>
          </div>
        </div>
      </a-form-model-item>
      <a-form-model-item ref="panoramic" :label="$t('form.common.field.panoramic.label')" prop="url">
        <div class="pano-video">
          <span class="tips">{{ $t("form.common.field.panoramic.tip") }}</span>
          <DragUploader ref="uploaderPanoramic" uptype="panoramic" :callback="getUploaderPanoramic"
            v-if="!panoramicform.url" @updateFileProgress="updateFileProgress">
            <a-spin :spinning="uploading" :tip="percent" slot="body">
              <a-button type="primary">{{$t("form.common.field.panoramic.label")}}</a-button>
            </a-spin>
          </DragUploader>
          <div class="video-list" v-else>
            <div class="video-icon"><a-icon type="caret-right" /></div>
            <div class="video-names">
              <span class="names">{{ panoramicform.name }}</span><span class="types">.{{ panoramicform.type }}</span>
            </div>
            <h5>{{ $t("form.common.field.panoramic.successMsg") }}</h5>
            <span class="close-icon" @click.stop="clearPanoramicVideo"><a-icon type="plus" :rotate="45" /></span>
          </div>
        </div>
      </a-form-model-item>
    </a-form-model>
    <!-- 直播 -->
  </div>
</template>

<script>
import DragUploader from "@/components/DragUploader";
import { materialAdd } from "@/api/planeMaterial";
import { mapGetters } from "vuex";

export default {
  props: {
    dir_id: {
      type: Number,
      required: true,
    },
  },
  components: { DragUploader },
  data() {
    return {
      panoramicRules: {
        cover: [
          {
            required: true,
            message: this.$t("form.common").field.cover.message,
            trigger: "blur",
          },
        ],
        url: [
          {
            required: true,
            message: this.$t("form.common").field.panoramic.message,
            trigger: "blur",
          },
        ],
      },
      isShowPanoramicModal: false,
      uploadingCover: false,
      uploading: false,
      panoramicform: {
        cover: "",
        url: "",
        name: "",
        filesize: "",
        type: "",
      },
      percent: "0%",
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    init() {
      this.panoramicform = {
        ...this.panoramicform,
        cover: "",
        url: "",
        name: "",
        filesize: "",
        type: "",
      };
    },
    getUploaderCover(up) {
      this.$nextTick(() => {
        up.bind("FilesAdded", (up, file) => {
          this.uploadingCover = true;
        });
        up.bind("Error", (up, file) => {
          this.uploadingCover = false;
        });
        up.bind("UploadComplete", (up, file) => {
          this.uploadingCover = false;
          this.panoramicform.cover = this.$refs.uploaderCover.fileList[0].url;
          this.$refs.panoramicform.clearValidate("cover");
        });
      });
    },
    getUploaderPanoramic(up) {
      this.$nextTick(() => {
        up.bind("FilesAdded", (up, file) => {
          this.uploading = true;
        });
        up.bind("Error", (up, file) => {
          this.uploading = false;
        });
        up.bind("UploadComplete", (up, file) => {
          this.uploading = false;
          this.panoramicform.url = this.$refs.uploaderPanoramic.fileList[0].url;
          this.panoramicform.name = this.$refs.uploaderPanoramic.fileList[0].name;
          this.panoramicform.filesize = this.$refs.uploaderPanoramic.fileList[0].filesize;
          this.panoramicform.type = file[0].type.split("/")[1];
          this.$refs.panoramicform.clearValidate("url");
        });
      });
    },
    clearPanoramicVideo() {
      this.panoramicform = {
        ...this.panoramicform,
        url: "",
        name: "",
        filesize: "",
        type: "",
      };
    },
    savePanoramic() {
      this.$refs.panoramicform.validate((valid) => {
        if (valid) {
          let data = [{ ...this.panoramicform, type: 4, dir_id: this.dir_id }];
          materialAdd(data).then((res) => {
            if (res.code == 1) {
              this.$message.success(this.$t("message.saveSuccess"));
              this.$emit("refresh");
              this.$emit("cancel");
            }
          });
        }
      });
    },
    updateFileProgress(percent) {
      this.percent = percent ? percent + "%" : "0%";
    },
  },
};
</script>

<style lang="less" scoped>
.pano-video-box {
  padding: 0 10px;

  .pano-video-cover {
    position: relative;
    padding: 10px 0 30px 0;
    border-bottom: 1px solid #efefef;

    .pano-cover {
      width: 200px;
      height: 200px;
      border-radius: 5px;
      background-color: #f1f1f1;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      .close-cover {
        position: absolute;
        z-index: 1000;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-size: 16px;
        top: 5px;
        right: 5px;
        transition: background-color 0.3s ease;
        cursor: pointer;

        &:hover {
          background-color: rgba(0, 0, 0, 0.8);
        }
      }

      .cover-data {
        width: 100%;
        height: 100%;
        text-align: center;
        font-size: 0;
        padding: 70px 20px 0 20px;
        line-height: normal;

        span {
          width: 36px;
          height: 36px;
          line-height: 34px;
          border-radius: 50%;
          background-color: #1890ff;
          color: #ffffff;
          font-size: 22px;
          display: inline-block;
        }

        h4 {
          font-size: 14px;
          margin-top: 10px;
          line-height: 160%;
          color: #999;
        }
      }
    }
  }

  .pano-video {
    position: relative;
    padding-top: 10px;

    .specialBtn {
      background-color: #7101ad;
      border-color: #7101ad;
    }

    .video-list {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .video-icon {
        flex-shrink: 0;
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background-color: #1890ff;
        color: #ffffff;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
        margin-right: 10px;
      }

      .video-names {
        margin-bottom: 0;
        flex: 1;
        display: flex;
        align-items: center;
        overflow: hidden;

        .names {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .types {
          flex-shrink: 0;
        }
      }

      h5 {
        width: 100px;
        flex-shrink: 0;
        text-align: center;
        margin: 0 10px;
        color: #1890ff;
      }

      .close-icon {
        width: 22px;
        height: 22px;
        text-align: center;
        line-height: 22px;
        border-radius: 50%;
        background-color: rgba(0, 0, 0, 0.5);
        font-size: 14px;
        color: #ffffff;
        flex-shrink: 0;
      }
    }
  }

  .tips {
    position: absolute;
    top: -27px;
    right: 0;
    z-index: 10;
    font-size: 12px;
    margin-left: 10px;
    color: #999;
    line-height: normal;
  }
}

@media (max-width: 767px) {
  .pano-video-box {
    padding: 0;

    /deep/ .ant-form-item-label {
      padding-bottom: 0;
    }

    .pano-video-cover {
      padding: 0 0 30px 0;
      line-height: normal;

      .pano-cover {
        width: 200px;
        height: 200px;
      }
    }

    .pano-video {
      padding-top: 0;
      line-height: normal;

      .video-list {
        .video-icon {
          width: 20px;
          height: 20px;
          line-height: 18px;
          margin-right: 6px;
          font-size: 12px;
        }

        h5 {
          width: 80px;
          margin: 0 10px;
        }

        .close-icon {
          width: 20px;
          height: 20px;
          line-height: 18px;
          font-size: 12px;
        }
      }
    }

    .tips {
      position: inherit;
      top: auto;
      right: auto;
      font-size: 12px;
      display: inline-block;
      margin: 3px 0 10px 0;
    }
  }
}
</style>